/**
 * Single source of truth for an event's public website URL.
 *
 * Mirrors the three-branch logic previously inlined in
 * `WebsiteStatus.tsx` (dev → localstack, custom domain, prod subdomain).
 * The AI studio used to fabricate `https://{eventId}.veltric.app`
 * unconditionally, which is wrong on localhost/staging and ignores custom
 * domains — use this everywhere instead.
 */
export function buildLiveUrl(
  eventId: string,
  customDomain?: string | null,
): string {
  if (!eventId) return "";
  if (import.meta.env.DEV) {
    // Bucket name must match the backend's R2Service destination
    // ("landing-pages") — "landingpages-plus" never existed in LocalStack,
    // so "Open live site" served a NoSuchKey XML in dev (audit G9).
    return `http://localhost:4566/landing-pages/${eventId}/index.html`;
  }
  if (customDomain) return `https://${customDomain}`;
  return `https://${eventId}.veltric.app`;
}
